"use client";

import { useTranslations } from "next-intl";
import { ArrowRightIcon } from "lucide-react";

interface FaqItem {
  question: string;
  answer: string;
}

export function AiAccessCheckerFAQ() {
  const t = useTranslations();
  
  const faqs: FaqItem[] = [
    {
      question: t("marketing.aiAccessChecker.faq.q1.question"),
      answer: t("marketing.aiAccessChecker.faq.q1.answer"),
    },
    {
      question: t("marketing.aiAccessChecker.faq.q2.question"),
      answer: t("marketing.aiAccessChecker.faq.q2.answer"),
    },
    {
      question: t("marketing.aiAccessChecker.faq.q3.question"),
      answer: t("marketing.aiAccessChecker.faq.q3.answer"),
    },
    {
      question: t("marketing.aiAccessChecker.faq.q4.question"),
      answer: t("marketing.aiAccessChecker.faq.q4.answer"),
    },
    {
      question: t("marketing.aiAccessChecker.faq.q5.question"),
      answer: t("marketing.aiAccessChecker.faq.q5.answer"),
    },
    {
      question: t("marketing.aiAccessChecker.faq.q6.question"),
      answer: t("marketing.aiAccessChecker.faq.q6.answer"),
    },
    {
      question: t("marketing.aiAccessChecker.faq.q7.question"),
      answer: t("marketing.aiAccessChecker.faq.q7.answer"),
    },
    {
      question: t("marketing.aiAccessChecker.faq.q8.question"),
      answer: t("marketing.aiAccessChecker.faq.q8.answer"),
    },
  ];
  
  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-4">
              {t("marketing.aiAccessChecker.faq.title")}
            </h2>
          </div>
          
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <details 
                key={index} 
                className="group bg-background rounded-lg border"
              >
                <summary className="flex items-center justify-between w-full p-6 text-left cursor-pointer">
                  <h3 className="font-semibold pr-4">
                    {faq.question}
                  </h3>
                  <div className="ml-4 flex-shrink-0">
                    <ArrowRightIcon className="w-5 h-5 text-muted-foreground group-open:rotate-90 transition-transform" />
                  </div>
                </summary>
                <div className="px-6 pb-6">
                  <p className="text-muted-foreground">
                    {faq.answer}
                  </p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
